import React, { Component } from "react"
import { PropTypes } from "prop-types"
import { Col, FormGroup, Row, Panel } from "react-bootstrap"
import  { red, green, warning } from '../../../utils/constants'
import { isEmpty } from "../../../utils/functions";

const box = { 
	textAlign: 'left',
	minWidth: '380px',
	minHeight:'290px',
    padding: '6px 0 0 8px',
    margin:'-10px 0 10px 0',
	fontSize:'13px',
	fontWeight:'bold',
}

const EventStatusDesc = {
  RulesDenied: 'Rules Denied',
  RulesApproved: 'Rules Approved',
  UpcomingEvent: 'Upcoming Events',
  Completed: 'Completed',
  Canceled: 'Canceled',
  SetupNotCompleted: 'Setup Not Complete',
  PendingApproval: 'Pending Approval',
  PendingPost: 'Pending Post Event Report',
}

class Adjustment extends Component {
    constructor(props)
    {
        super(props)
        this.state = {
            isError:false
        }
        this.handleCancel = this.handleCancel.bind(this);
        this.handleFundAdjustment = this.handleFundAdjustment.bind(this);
    }

    handleCancel(){
        this.props.onCancel();
    }

    handleFundAdjustment(){
        const { event } = this.props;
        const from = event.eventId;
        const amount = document.getElementById("amount").value;
        const notes = document.getElementById("notes").value;
        const transferObj = {
            from,
            amount,
            notes
        }
        
        if(isEmpty(amount)){
            this.setState({
                isError:true
            })
            return;
        } else {
            this.setState({
                isError:false
            })
        
            this.props.onSave(transferObj);
        }
    }
 
    render(){
        const { isError } = this.state
        const {
            saving,
            event
        } = this.props

        return (<Row>
        <Col sm={3}  >
            <Panel  style={{ ...box }}>
                <h5 style={{ color:green, marginTop:'-10px' }}>Fund Adjustment</h5>
                {isError && 
                    <p>
                        <span style={{ color:red }}>* Amount is required</span>
                    </p>
                } 
                <p>Season:&nbsp;&nbsp; {event.season}</p>
                <p>Event:&nbsp;&nbsp; {event.name}</p>
                <p>Amount:&nbsp;&nbsp;  <input type='number' id="amount" className="no-spinners" style={{ maxWidth:'80px', minHeight:'32px', padding:'5px' }} placeholder='$XX.XX'/></p>
                <p><span>Notes:</span>&nbsp;&nbsp;  <textarea rows='3' id="notes" style={{ minWidth:'270px', minHeight:'32px', padding:'5px', marginLeft:'12px' }} /></p>
                { event.status == EventStatusDesc.SetupNotCompleted &&
                (<span style={{ fontSize: '14px', fontWeight: 'bold', color: warning }}>
                <i className="fa fa-info-circle" aria-hidden="true" style={{ color: warning }} />&nbsp;&nbsp;Event set up is not complete - Please ensure set up is complete prior to making a fund adjustment&nbsp;
									</span>)
                }
                <FormGroup >
                    <button type="button"   className="btn btn-default" style={{ color: red, marginTop: '15px', marginLeft: '10px' }} onClick={this.handleCancel}>
                        <i className="fa fa-remove" aria-hidden="true" /> &nbsp;&nbsp;Cancel
                    </button>   
                    <button type="button" className="btn btn-default" style={{ color: green, marginTop: '15px', marginLeft:'10px' }} onClick={this.handleFundAdjustment}>
                        <i className={saving ? 'fa fa-spinner fa-spin' : "fa fa-dollar"} aria-hidden="true" /> &nbsp;&nbsp;Apply Adjustment
                    </button>                                     
                </FormGroup>
            </Panel>
        </Col>
        </Row>)
    }
}

Adjustment.propTypes = {
    onCancel:PropTypes.func,
    onSave:PropTypes.func,
    saving: PropTypes.bool,
    event: PropTypes.object
}

export default Adjustment



// WEBPACK FOOTER //
// ./src/containers/deposit/components/adjustment.js